<template>
    <zen-one :showuserinfo="false" title="Sistem Hasil Bersepadu Kedah (iHasil)" :crumbs="crumbs">
         <z-page title="LAPORAN INTERIM">
            <w-form ref="dform" @validate="search">
                
                <w-flex class="mt3">
                    <div class="xs6 mr3">
                        <w-input
                            v-model="cari.tarikh_dari"
                            required
                            label="Dari"
                            type="date"
                        />
                    </div>
                    <div class="xs6 mr3">
                        <w-input
                            v-model="cari.tarikh_hingga"
                            required
                            label="Hingga"
                            type="date"
                        />
                    </div>
                </w-flex>

            </w-form>

            <w-flex class="mt1 mb3" justify-end>
                <div class="mt2 text-right">
                    <w-button class="ml1" v-on:click="reset()" bg-color="warning">
                        <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                    </w-button>
                    <w-button class="ml1 " @click="$refs.dform.validate()">
                        <w-icon>fal fa-search</w-icon>&nbsp;Cari
                    </w-button>
                </div>
            </w-flex>
            <center v-if="loading == true"><w-progress class="ma1" circle></w-progress></center>
            <w-flex justify-center align-center class="mt5">
                <div class="w-card__content content-hardcode">
                    <table class="table-dashboard" width="100%">
                        <thead>
                            <tr>
                                <td>BIL</td>
                                <td>PERIHAL</td>
                                <td>JUMLAH BILANGAN DATA</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(dt, index) in table.items">
                                <td>{{ index+1 }}</td>
                                <td>{{ dt.keterangan }}</td>
                                <td style="text-align: right">
                                    <inertia-link v-if="dt.type != 'b'" :href="$route('kutipan.laporan.interim_lv2')+'?type='+dt.type + '&tarikh_dari=' + cari.tarikh_dari + '&tarikh_hingga=' +cari.tarikh_hingga+ '&title=' +dt.keterangan">
                                        {{ dt.amaun }}
                                    </inertia-link>
                                    <span v-else>
                                        {{ dt.amaun }}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </w-flex>
        

            <w-flex class="mt1 mb3" justify-center>
                <div class="mt2 text-center">
                    <w-button bg-color="success" class="mr3" @click="cetak()">
                        <w-icon>fal fa-print</w-icon>&nbsp;Cetak
                    </w-button>
                </div>
            </w-flex>
        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZenOne from '@/Shared/ZenOne'
import ZResource from '@/Modules/z-resource-service'


export default {
  extends: ZResource,
  components: {
    // ZenOne
  },
  props: {
    items: [Array, Object],
    auth: [Array, Object],
  },
  data() {
    return {
        resourceurl: this.service_laporan+'kutipan/laporan/dummy',
        reload: true,
        loading: false,
        status: [
            {
                value: 1,
                label: 'Aktif',
            },
            {
                value: 2,
                label: 'Tidak Aktif',
            },
        ],
        crumbs: [
            { label: 'iHasil', route: '/' },
            { label: 'Laporan Interim', route: '/kutipan/laporan/interim' },
          ],
          cari : {tarikh_dari: '', tarikh_hingga: ''},
          }
  },
  methods: {

    search() {
        this.getDataQuery();
    //   this.$inertia.visit(window.route('akaun_belum_terima.abt_1b')+'?bulan='+this.cari.bulan+'&tahun='+this.cari.tahun, {preserveScroll:true})
    },

    reset(){
      this.cari = {tarikh_dari: '', tarikh_hingga: ''}
      this.search()
    },
    cetak() {
            window.open(this.service_laporan+'kutipan/laporan/interim?cetak=true&user_id='+this.auth.user.id+
            "&tarikh_dari=" + this.cari.tarikh_dari +
            "&tarikh_hingga=" + this.cari.tarikh_hingga,'_blank');
        },
    async getDataQuery() {
        this.loading = true;
        const resp = await axios.get(
            this.service_laporan + "kutipan/laporan/interim?user_id=" + this.auth.user.id +
            "&tarikh_dari=" + this.cari.tarikh_dari +
            "&tarikh_hingga=" + this.cari.tarikh_hingga
        );
        this.table = resp.data;
        this.loading = false;
    },
  },
  watch: {
  },
  mounted() {
    // override default setting
    // this.getData();
    this.dialog.width = 900
    this.cari = location.search.slice(1).split('&').map(p => p.split('=')).reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
    if(this.cari.tarikh_dari == 'undefined'){this.cari.tarikh_dari = ''}
    if(this.cari.tarikh_hingga == 'undefined'){this.cari.tarikh_hingga = ''}
    if(this.cari.goback){
        this.getDataQuery();
    }
    
  },
}
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>